module.exports = __webpack_public_path__ + "assets/back.svg?77c8333715b9ff9d5643c0f029b67b03";